import React from 'react';
import QuadProd from './QuadProd';
import { SoftwareDB } from '../SoftwareDB';

function Softwares() {
  return (
    <section className="services">
            <div className="container">
                <div className="row">
                    <h2>Softwares Registrados</h2>
                    
                    {
                    SoftwareDB.map((user, i) => {
                    return (
                        <QuadProd  
                        key={i} 
                        titulo={SoftwareDB[i].titulo} 
                        meio={SoftwareDB[i].meio}
                        link={SoftwareDB[i].link} 
                        data={SoftwareDB[i].data} 
                        text1={SoftwareDB[i].text1} 
                        text2={SoftwareDB[i].text2} 
                        icon={SoftwareDB[i].icon}
                        />
                        );
                    })
                  }
                </div>
              </div>
    </section>
    

  );
}

export default Softwares;